export async function setAuthCookie(accessToken: string) {
  try {
    const response = await fetch(
      `${process.env.REACT_APP_API_END_POINT}authcookie/set-token`,
      {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${accessToken}`,
        },
        credentials: 'include',
      },
    );

    if (!response.ok) {
      console.error('Failed to set auth cookie:', response.status);
    }

    return response;
  } catch (err) {
    console.error('Error setting auth cookie:', err);
  }
}
